import $ from '@vaersaagod/tools/Dom';
import Viewport from '@vaersaagod/tools/Viewport';
import Dispatch from '@vaersaagod/tools/Dispatch';
import * as Events from '../lib/events';
import { lockScroll, releaseScroll } from '../lib/helpers';

export default el => {
    const MOBILE_BREAKPOINT = 750;

    let isMobile;
    let currentBreakpoint;
    let isOpen = false;

    const dom = $(el);
    const menuItems = dom.find('[data-menu-item]');
    const searchForm = dom.find('[data-menu-search-form]');
    const languageSelector = dom.find('[data-language-selector]');

    const emitClose = () => {
        Dispatch.emit(Events.MENU_CLOSE);
        Dispatch.emit(Events.SCROLL_UNLOCKED);
    };

    const keyup = e => {
        const key = e.keyCode || e.which;
        if (isOpen && key === 27) {
            emitClose();
        }
    };

    const open = () => {
        if (!isOpen && isMobile) {
            isOpen = true;
            dom.addClass('is-open');
            TweenMax.killTweensOf(el);
            // TweenMax.set(el, { display: 'block', opacity: 0, y: -20 });
            TweenMax.set(el, { display: 'block', opacity: 1, yPercent: -100 });
            TweenMax.to(el, 0.55, { yPercent: 0, opacity: 1, ease: Quint.easeInOut });
            // TweenMax.to(el, 0.55, { y: 0, opacity: 1, ease: Quint.easeInOut });
            TweenMax.set(menuItems.nodes, { opacity: 0, y: -45 });
            TweenMax.staggerTo(menuItems.nodes.reverse(), 1, { opacity: 1, y: 0, delay: 0.2, ease: Quint.easeOut }, 0.1);
            TweenMax.set(searchForm.nodes, { opacity: 0 });
            TweenMax.to(searchForm.nodes, 1, { opacity: 1, delay: 0.6, ease: Quint.easeOut });
            TweenMax.set(languageSelector.nodes, { opacity: 0 });
            TweenMax.to(languageSelector.nodes, 1, { opacity: 1, delay: 0.6, ease: Quint.easeOut });
            document.addEventListener('keyup', keyup);
            lockScroll($('[data-nav-scroll]').get(0));
        }
    };

    const close = () => {
        if (isOpen && isMobile) {
            isOpen = false;
            TweenMax.killTweensOf(el);
            TweenMax.to(searchForm.nodes, 0.15, { opacity: 0, ease: Quad.easeIn });
            TweenMax.to(languageSelector.nodes, 0.15, { opacity: 0, ease: Quad.easeIn });
            TweenMax.staggerTo(menuItems.nodes.reverse(), 0.25, { opacity: 0, y: -30, ease: Quad.easeIn }, 0.05);
            TweenMax.to(el, 0.55, { yPercent: -100, opacity: 1, ease: Quint.easeInOut, clearProps: 'all', delay: 0.1, onComplete: () => { dom.removeClass('is-open'); releaseScroll(); } });
            document.removeEventListener('keyup', keyup);
        }
    };

    const init = () => {
        currentBreakpoint = Viewport.breakpoint.size;
        isMobile = currentBreakpoint < MOBILE_BREAKPOINT;
        if (isMobile) {
            Viewport.disableTabbingOnElement(el);
        }
        Viewport.on('breakpoint', onBreakpoint);
        Dispatch.on(Events.MENU_OPEN, open);
        Dispatch.on(Events.MENU_CLOSE, close);
    };

    const onBreakpoint = () => {
        currentBreakpoint = Viewport.breakpoint.size;
        const wasMobile = isMobile;
        isMobile = currentBreakpoint < MOBILE_BREAKPOINT;
        console.log('onBreakpoint', currentBreakpoint);

        if (wasMobile !== isMobile) {
            dom.removeClass('is-open');
        }

        if (wasMobile && !isMobile) {
            TweenMax.set(el, { clearProps: 'all' });
            TweenMax.set(menuItems.nodes, { clearProps: 'all' });
            isOpen = false;
            releaseScroll();
        } else if (isMobile && !wasMobile) {
            Viewport.disableTabbingOnElement(el);
        }
    };

    const destroy = () => {
        Viewport.off('breakpoint', onBreakpoint);
        Dispatch.off(Events.MENU_OPEN, open);
        Dispatch.off(Events.MENU_CLOSE, close);
        TweenMax.killTweensOf(el);
    };

    return {
        init,
        destroy
    };
};



// WEBPACK FOOTER //
// ./src/js/components/Menu.js